import { types } from '../types/types';

const initialState = {
    signin: false,
    checking: true,
    url_foto: '',
    access: []
}

export const authReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.authLogin:
            return {
                ...state,
                ...action.payload,
                checking: false
            }

        case types.authCheckingFinish:
            return {
                ...state,
                checking: false
            }

        case types.authLogout:
            return {
                checking: false
            }

        case types.authUpdatePhoto:
            return {
                ...state,
                url_foto: action.payload
            }

        default:
            return state;
    }

}